export const routes = {
  AUTH: '/auth',
  HOME: '/',
  SET_GAME: '/set_game',
  GAME: '/game',
  SETTINGS: '/settings',
  RATING: '/rating',
  ABOUT: '/about',
  USER: '/user/:name?',
};
